$(window).on('load', function() {
  setTimeout(() => {
    $('#message-bar').fadeOut(500);
    }, 2500)
  $('.home-qa-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('open', 1000)
  });
});